import React from 'react';
import './style.scss'
import {
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    LineElement,
    PointElement,
    Title,
    Tooltip,
} from 'chart.js';
import {Line} from 'react-chartjs-2';

import {useSelector} from "react-redux";
import {selectController} from "../../redux/stores";


ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

export const options = {
    responsive: true,
    interaction: {
        mode: 'index' as const,
        intersect: false,
    },
    stacked: false,
    plugins: {
        title: {
            display: true,
            text: 'WTG043',
        },
    },
    scales: {
        y: {
            type: 'linear' as const,
            display: true,
            position: 'left' as const,
        },

    },
    maintainAspectRatio: false,
};

const labels = ['06:30', '06:45', '07:00', '07:15', '07:30', '07:45', '08:00', '08:15', '08:30'];


export const data = {
    labels,
    datasets: [
        {
            label: 'Observed',
            data: labels.map(() => Math.floor(Math.random() * 1000)),
            borderColor: 'rgb(255, 99, 132)',
            backgroundColor: 'rgba(255, 99, 132, 0.5)',
            yAxisID: 'y',
        },
        {
            label: 'Physical',
            data: labels.map(() => Math.floor(Math.random() * 1000)),
            borderColor: 'rgb(53, 162, 235)',
            backgroundColor: 'rgba(53, 162, 235, 0.5)',
            yAxisID: 'y',
        },
        {
            label: 'Model',
            data: labels.map(() => Math.floor(Math.random() * 1000)),
            borderColor: 'rgb(53, 10, 100)',
            backgroundColor: 'rgba(53, 10, 100, 0.5)',
            yAxisID: 'y',
        },
    ],
};


const DataChart = () => {

    const isShownDataChart = useSelector(selectController)

    return (
        <div className={'data-chart ' + (isShownDataChart? 'toggle': '')} >
            <Line options={options} data={data}/>
        </div>
    )
}

export default DataChart
